import { Component, Inject, Input, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AppComponent } from "../app/app.component";

@Component({
    selector: 'nav-menu',
    template: require('./navmenu.component.html'),
    styles: [require('./navmenu.component.css')]
})
export class NavMenuComponent {
    
    InsuranceLogo: any;
    //report!: CollisionReport;
    constructor(public appcomponent: AppComponent) {
        //var driverInsurance = yourinfo.getInsuranceCompany.toString();

        //var insurance = /aviva/gi;

        //if (driverInsurance.search(insurance) != -1) {
            //this.InsuranceLogo = '/dist/assets/img/InsuranceLogo/AvivaLogo.png'
        //}
    }

}
